import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TreeSelect from 'antd/lib/tree-select';

import 'antd/lib/tree-select/style/css';

class StopAdder extends Component {
  static propTypes = {
    orders: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any,
    error: PropTypes.string,
  }

  constructor(props) {
    super(props);

    this.onCheck = this.onCheck.bind(this);

    this.state = {
      stops: null,
      selectedStops: []
    }
  }

  componentWillMount() {
    const { orders } = this.props;
    const s = _.groupBy(orders, item => item.order.to.address.id);

    const stops = this.processStops(s);

    this.setState({
      stops
    });
  }

  processStops = (stops) => {
    const s = [];
    _.forEach(stops, (value, key) => {
      const label = `${value[0].order.to.name}: ${value[0].order.to.address.address}`;
      s.push({
        label,
        value: `0-${key}`,
        children: _.map(value, itm => ({ label: itm.trackingNumber, value: itm.trackingNumber, locationId: value[0].order.to.id }))
      })
    });
    return s;
  }

  onCheck = (obj) => {
    const { checkedNodes } = obj;
    
    const selectedStops = _.filter(checkedNodes, (item) => {
      return (item.key.indexOf('0-') !== 0);
    });
    const a = _.map(selectedStops, item => _.pick(item, ['props.value','props.locationId']));
    const stops = _.groupBy(a, item => item.props.locationId);
    this.props.input.onChange(stops);
  }

  render() {
    const { error, stops } = this.state;
    const tProps = {
      treeData: stops,
      treeCheckable: true,
      showCheckedStrategy: TreeSelect.SHOW_PARENT,
      searchPlaceholder: 'Please select',
      onSelect: (value, node, extra) => this.onCheck(extra),
      style: {
        width: '100%',
      },
    }

    let content = <TreeSelect {...tProps} />;

    return (
      <div className="row">
        <div className="col s12">
          {error &&
            <div className="col s12">{error}</div>
          }
          {content}
        </div>
      </div>
      
    );
  }
}

export default StopAdder;


// WEBPACK FOOTER //
// ./src/components/Dispatcher/Manifests/StopAdder.js